import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { AxiosError } from 'axios'
import { LoadingState, ValidationError } from '../../../types/commonTypes'
import { ApiLoadingState } from '../../../middleware/api/apiList'
import { AppDispatch, RootState } from '../../../stateStore'
import IntervieweeDetailsApi from '../../../middleware/api/Recruitment/IntervieweeDetails/IntervieweeDetailsApi'
import {
  CheckEmployeeAvailabilityProps,
  CycleDtOs,
  EmpScheduleInterviewData,
  EmployeeProperties,
  IntervieweeDetailsSliceState,
  Reschedule,
  Schedule,
  TimeLineList,
  UpdateProps,
  UploadProps,
  saveButnprops,
  timeLineDetails,
} from '../../../types/Recruitment/IntervieweeDetails/IntervieweeDetailsTypes'

const timeLineData = createAsyncThunk(
  'IntervieweeDetails/timeLineDetails',
  async (candidateId: number, thunkApi) => {
    try {
      return await IntervieweeDetailsApi.timeLineDetails(candidateId)
    } catch (error) {
      const err = error as AxiosError
      return thunkApi.rejectWithValue(err.response?.status as ValidationError)
    }
  },
)

const saveInitialComments = createAsyncThunk(
  'IntervieweeDetails/saveInitialComments',
  async (props: saveButnprops, thunkApi) => {
    try {
      return await IntervieweeDetailsApi.saveInitialComments(props)
    } catch (error) {
      const err = error as AxiosError
      return thunkApi.rejectWithValue(err.response?.status as ValidationError)
    }
  },
)

const updateCandidateInterviewStatus = createAsyncThunk(
  'IntervieweeDetails/updateCandidateInterviewStatus',
  async (props: UpdateProps, thunkApi) => {
    try {
      return await IntervieweeDetailsApi.updateCandidateInterviewStatus(props)
    } catch (error) {
      const err = error as AxiosError
      return thunkApi.rejectWithValue(err.response?.status as ValidationError)
    }
  },
)

const empScheduleInterviewDetails = createAsyncThunk(
  'IntervieweeDetails/empScheduleInterviewDetails',
  async (interviewCycleId: number, thunkApi) => {
    try {
      return await IntervieweeDetailsApi.empScheduleInterviewDetails(
        interviewCycleId,
      )
    } catch (error) {
      const err = error as AxiosError
      return thunkApi.rejectWithValue(err.response?.status as ValidationError)
    }
  },
)

const updateInterview = createAsyncThunk(
  'IntervieweeDetails/updateInterview',
  async (props: EmpScheduleInterviewData, thunkApi) => {
    try {
      return await IntervieweeDetailsApi.updateInterview(props)
    } catch (error) {
      const err = error as AxiosError
      return thunkApi.rejectWithValue(err.response?.status as ValidationError)
    }
  },
)

const reScheduleInterview = createAsyncThunk(
  'IntervieweeDetails/reScheduleInterview',
  async (props: Reschedule, thunkApi) => {
    try {
      return await IntervieweeDetailsApi.reScheduleInterview(props)
    } catch (error) {
      const err = error as AxiosError
      return thunkApi.rejectWithValue(err.response?.status as ValidationError)
    }
  },
)

const scheduleInterview = createAsyncThunk(
  'IntervieweeDetails/scheduleInterview',
  async (props: Schedule, thunkApi) => {
    try {
      return await IntervieweeDetailsApi.scheduleInterview(props)
    } catch (error) {
      const err = error as AxiosError
      return thunkApi.rejectWithValue(err.response?.status as ValidationError)
    }
  },
)

const checkEmployeeAvailability = createAsyncThunk(
  'IntervieweeDetails/checkEmployeeAvailability',
  async (props: CheckEmployeeAvailabilityProps, thunkApi) => {
    try {
      return await IntervieweeDetailsApi.checkEmployeeAvailability(props)
    } catch (error) {
      const err = error as AxiosError
      return thunkApi.rejectWithValue(err.response?.status as ValidationError)
    }
  },
)

const getAllEmployeeDetails = createAsyncThunk(
  'IntervieweeDetails/getAllEmployeeDetails',
  async (_, thunkApi) => {
    try {
      return await IntervieweeDetailsApi.getAllEmployeeDetails()
    } catch (error) {
      const err = error as AxiosError
      return thunkApi.rejectWithValue(err.response?.status as ValidationError)
    }
  },
)

const interviewRoundCount = createAsyncThunk(
  'IntervieweeDetails/interviewRoundCount',
  async (candidateId: number, thunkApi) => {
    try {
      return await IntervieweeDetailsApi.interviewRoundCount(candidateId)
    } catch (error) {
      const err = error as AxiosError
      return thunkApi.rejectWithValue(err.response?.status as ValidationError)
    }
  },
)

const sendRejectedMessagetoCandidate = createAsyncThunk(
  'IntervieweeDetails/sendRejectedMessagetoCandidate',
  async (candidateId: number, thunkApi) => {
    try {
      return await IntervieweeDetailsApi.sendRejectedMessagetoCandidate(
        candidateId,
      )
    } catch (error) {
      const err = error as AxiosError
      return thunkApi.rejectWithValue(err.response?.status as ValidationError)
    }
  },
)
export const initialIntervieweeDetailsState: IntervieweeDetailsSliceState = {
  isLoading: ApiLoadingState.idle,
  listSize: 0,
  timeLineList: {} as TimeLineList,
  cycleDtOs: {} as CycleDtOs,
  CycleDtOsList: [],
  timeLineDetails: {} as timeLineDetails,
  scheduleInterviewData: {} as EmpScheduleInterviewData,
  addNewJoineeTechnology: {} as UpdateProps,
  employeeProperties: [],
  isHold: false,
  isReject: false,
  isNoShow: false,
  paginationCache: {
    currentPage: 0,
    pageSize: 20,
  },
  isUpdateButtons: false,
}
const IntervieweeDetailsSlice = createSlice({
  name: 'IntervieweeDetails',
  initialState: initialIntervieweeDetailsState,
  reducers: {
    clearAPiData: (state, action) => {
      state.scheduleInterviewData = action.payload
    },
    setButtonsInTimeline: (state, action) => {
      const { name, value } = action.payload
      if (name === 'isHold') {
        state.isHold = value
      } else if (name === 'isNoShow') {
        state.isNoShow = value
      } else if (name === 'isReject') {
        state.isReject = value
      }
    },
    setIsHold: (state, action) => {
      state.isHold = action.payload
    },
    setIsReject: (state, action) => {
      state.isReject = action.payload
    },
    setIsNoShow: (state, action) => {
      state.isNoShow = action.payload
    },
    setPaginationCache: (state, action) => {
      state.paginationCache = action.payload
    },
    setAllToFalse: (state) => {
      state.isHold = false
      state.isNoShow = false
      state.isReject = false
    },
    setIsUpdateButtons: (state, action) => {
      state.isUpdateButtons = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(timeLineData.fulfilled, (state, action) => {
        state.isLoading = ApiLoadingState.succeeded
        state.timeLineList = action.payload
      })
      .addCase(empScheduleInterviewDetails.fulfilled, (state, action) => {
        state.isLoading = ApiLoadingState.succeeded
        state.scheduleInterviewData = action.payload
      })
      .addCase(updateCandidateInterviewStatus.fulfilled, (state, action) => {
        state.isLoading = ApiLoadingState.succeeded
        state.addNewJoineeTechnology = action.payload
      })
      .addCase(getAllEmployeeDetails.fulfilled, (state, action) => {
        state.isLoading = ApiLoadingState.succeeded
        state.employeeProperties = action.payload
      })
      .addCase(timeLineData.pending, (state) => {
        state.isLoading = ApiLoadingState.loading
      })
      .addCase(uploadCandidatePicture.pending, (state) => {
        state.isLoading = ApiLoadingState.loading
      })
      .addCase(uploadCandidatePicture.fulfilled, (state) => {
        state.isLoading = ApiLoadingState.succeeded
      })
  },
})
const uploadCandidatePicture = createAsyncThunk<
  number | undefined,
  UploadProps,
  {
    dispatch: AppDispatch
    state: RootState
    rejectValue: ValidationError
  }
>(
  'InterviewDetails/uploadCandidatePicture',
  async (prepareObject: UploadProps, thunkApi) => {
    try {
      return await IntervieweeDetailsApi.uploadCandidatePicture(prepareObject)
    } catch (error) {
      const err = error as AxiosError
      return thunkApi.rejectWithValue(err.response?.status as ValidationError)
    }
  },
)

export const intervieweeDetailsThunk = {
  timeLineData,
  uploadCandidatePicture,
  saveInitialComments,
  updateCandidateInterviewStatus,
  empScheduleInterviewDetails,
  updateInterview,
  getAllEmployeeDetails,
  interviewRoundCount,
  reScheduleInterview,
  scheduleInterview,
  checkEmployeeAvailability,
  sendRejectedMessagetoCandidate,
}

const listSize = (state: RootState): number => state.intervieweeDetails.listSize

const isLoading = (state: RootState): LoadingState =>
  state?.intervieweeDetails.isLoading

const addJoineeSelector = (state: RootState): UpdateProps =>
  state.intervieweeDetails.addNewJoineeTechnology

const cycleDtOsList = (state: RootState): CycleDtOs =>
  state.intervieweeDetails.cycleDtOs

const cycleDtOsArrayList = (state: RootState): CycleDtOs[] =>
  state.intervieweeDetails.CycleDtOsList

const TimeLineListSelector = (state: RootState): TimeLineList =>
  state.intervieweeDetails.timeLineList

const scheduleInterviewData = (state: RootState): EmpScheduleInterviewData =>
  state.intervieweeDetails.scheduleInterviewData

const timeLineSelector = (state: RootState): timeLineDetails =>
  state.intervieweeDetails.timeLineDetails

const employeeProperties = (state: RootState): EmployeeProperties[] =>
  state.intervieweeDetails.employeeProperties

const scheduleInterviewSelector = (
  state: RootState,
): EmpScheduleInterviewData => state.intervieweeDetails.scheduleInterviewData

const getIsHold = (state: RootState): boolean => state.intervieweeDetails.isHold
const getIsNoShow = (state: RootState): boolean =>
  state.intervieweeDetails.isNoShow
const getIsReject = (state: RootState): boolean =>
  state.intervieweeDetails.isReject

const getIsUpdateButtons = (state: RootState): boolean =>
  state.intervieweeDetails.isUpdateButtons

const getPaginationCache = (
  state: RootState,
): { currentPage: number; pageSize: number } =>
  state.intervieweeDetails.paginationCache

export const intervieweeDetailsSelectors = {
  listSize,
  isLoading,
  timeLineSelector,
  cycleDtOsList,
  cycleDtOsArrayList,
  TimeLineListSelector,
  scheduleInterviewSelector,
  scheduleInterviewData,
  addJoineeSelector,
  employeeProperties,
  getIsHold,
  getIsNoShow,
  getPaginationCache,
  getIsReject,
  getIsUpdateButtons,
}

export const intervieweeDetailsService = {
  ...intervieweeDetailsThunk,
  actions: IntervieweeDetailsSlice.actions,
  selectors: intervieweeDetailsSelectors,
}

export default IntervieweeDetailsSlice.reducer
